<template>
  <Map></Map>
</template>
<script>
   import Map from '../components/Map'

   export default {
    name: 'HomeView',
    components: {
      Map
    },
    mounted: function() {
      
    },
    data: () => ({

    }),

    props: {

    },

    computed: {
     mapdrawer: {
        get() {
          return this.$store.state.mapdrawer;
        },
        set(value) {
          this.$store.commit("set_mapdrawer", value);
        }
      },      
      properties: {
        get() {
          return this.$store.state.properties;
        },
        set(value) {
          this.$store.commit("set_properties", value);
        }
      },
      isAdmin: {
        get() {
          return this.$store.state.isAdmin;
        },
        set(value) {
          this.$store.commit("set_isAdmin", value);
        }
      },
      siteTitle: {
        get() {
          return this.$store.state.siteTitle;
        },
        set(value) {
          this.$store.commit("set_siteTitle", value);
        }
      },
      siteName: {
        get() {
          return this.$store.state.siteName;
        },
        set(value) {
          this.$store.commit("set_siteName", value);
        }
      },
    },

    methods: {
      
    }
   }
</script>
